'use client'
import { useState, type ReactNode } from 'react'

/**
 * A titled form section that collapses to a one-line subtitle.
 * Collapsed by default; pass defaultOpen to start expanded (e.g. when editing
 * an item that already has non-default settings worth surfacing).
 */
export default function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = false,
  children,
}: {
  title: ReactNode
  subtitle: string
  defaultOpen?: boolean
  children: ReactNode
}) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className="flex flex-col gap-2">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="flex items-center justify-between gap-2 text-left group"
      >
        <span className="flex flex-col">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</span>
          {!open && <span className="text-xs font-normal text-gray-400">{subtitle}</span>}
        </span>
        <svg
          className={`h-4 w-4 shrink-0 text-gray-400 transition-transform group-hover:text-gray-600 dark:group-hover:text-gray-200 ${open ? 'rotate-180' : ''}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.22 8.22a.75.75 0 011.06 0L10 11.94l3.72-3.72a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.22 9.28a.75.75 0 010-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {open && children}
    </div>
  )
}
